import React from 'react';
import TextField from 'material-ui/TextField';
import {black} from 'material-ui/styles/colors';
import Search from 'material-ui/svg-icons/action/search';
import PropTypes from 'prop-types';
import commonStyles from '../../../styles/styles';
import styles from './SearchBox.css';
import withTranslation from "../../../hoc/withTranslation";

const SearchBox = (props) => {
    return (
        <div style={styles.container}>
            <Search style={styles.iconButton} color={black} />
            <div>
            <TextField
                id="search"
                hintText={props.t('module.open_explore.search')}
                underlineShow={false}
                fullWidth={false}
                style={styles.textField}
                inputStyle={styles.inputStyle}
                hintStyle={styles.hintStyle}
                onChange={props.onChange}
                value={props.value}
            />
            </div>
            <div style={commonStyles.clear}/>
        </div>
    );
};

SearchBox.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string
};

export default withTranslation(SearchBox);



// WEBPACK FOOTER //
// src/components/common/SearchBox/SearchBox.js